import { Message } from 'element-ui'
import store from '@/store'

/**
 * 判断当前用户是否为管理员并确保返回值为bool类型
 * @returns {boolean}
 */
const $isAdmin = () => {
  let currentUser = store.state.user
  let r = currentUser.roleIdList.find(r => r === '1497144338753867777')
  if (r) {
    return true
  }
  return false
}
const $str2bool = (str) => {
  if (str) {
    return true
  }
  return false
}

const $success = (msg, duration) => {
  let p = new Promise((resolve, reject) => {
    Message({
      message: msg || '操作成功',
      type: 'success',
      duration: duration || 1500,
      onClose: () => {
        resolve()
      }
    })
  })
  return p
}

const $error = (msg, duration) => {
  let p = new Promise((resolve, reject) => {
    Message({
      message: msg || '操作失败',
      type: 'error',
      duration: duration || 1500,
      onClose: () => {
        resolve()
      }
    })
  })
  return p
}

const $companyName = name => {
  if (!name) {
    return ''
  }
  return name.replace('有限责任公司', '').replace('有限公司', '')
}

const $companyNameFormatter = (row, column, cellValue, index) => {
  return $companyName (cellValue)
}

/**
 * 判断数组是否为空
 * @param arr
 * @returns {boolean} 空数组返回true否则返回false
 */
const $isArrayEmpty = (arr) => {
  return !arr || arr.length === 0
}
/**
 * 数据字典格式化显示
 * @param type
 * @param val
 * @returns {string|[{trigger: string, message: *, required: boolean}]|*|string}
 */
const $dictFormat = (type, val) => {
  let dm = store.state.dictMap
  if (!dm) {
    return ''
  }
  let p = dm.find((item) => item.dictType === type)
  if (!p || !p.children) {
    return
  }
  let c = p.children.find((item) => item.dictValue === String(val))
  if (!c) {
    return ''
  }
  return c.dictName
}

const $prettyNum = (num) => {
  if (num === '' || num === null || num === undefined) {
    return 0
  }

  let ns = String(num)
  let p = ns.indexOf('.')
  if (p === -1) {
    return ns
  }
  let ei = -1
  for (let i = ns.length - 1; i > p; i--) {
    if (ns[i] !== '0') {
      ei = i
      break
    }
  }
  if (ei > -1) {
    return ns.substring(0, ei + 1)
  } else {
    return ns.substring(0, p + 3)
  }
}

const $productName = (product) => {
  let defaultKeys = ['code', 'skuCode', 'name', 'nameZh', 'color', 'size', 'attr1', 'attr2']
  let fullNameAttr = []
  defaultKeys.forEach(dk => {
    if(!product[dk]){
      return
    }
    fullNameAttr.push(product[dk])
  })
  return fullNameAttr.join(' ')
}

const $prettyNumFormatter = (row, column, cellValue, index) => {
  return $prettyNum(cellValue)
}

const common = {
  success: $success,
  error: $error,
  str2bool: $str2bool,
  companyName: $companyName,
  companyNameFormatter: $companyNameFormatter,
  isArrayEmpty: $isArrayEmpty,
  dictFormat: $dictFormat,
  isAdmin: $isAdmin,
  prettyNum: $prettyNum,
  prettyNumFormatter: $prettyNumFormatter,
  productName: $productName
}

export default common
